<template>
  <Card class="card" :title="$t('loginHelpPage.title')" :maxWidth="700">
    <template v-slot:content>
      <ImageWrapper
        imagePath="assets/images/Weitere_Anliegen"
        imageName="Weitere_Anliegen"
        :breakpoints="[365, 450, 580, 639, 776]"
      ></ImageWrapper>
      <div>{{ $t('loginHelpPage.info') }}</div>
      <br />
      <div v-dompurify-html="$t('loginHelpPage.info-additional')"></div>
    </template>
    <template v-slot:footer>
      <div class="footer-cta footer-cta--right">
        <CustomButton
          @click="goToRegistration"
          id="registration-button"
          class="button--cta2"
          :buttonColor="ButtonColor.SECONDARY"
          >{{ $t('loginHelpPage.go-to-registration-button') }}
        </CustomButton>
        <CustomButton
          @click="goToLogin"
          id="login-button"
          :buttonColor="ButtonColor.SECONDARY"
          >{{ $t('loginHelpPage.back-to-login-button') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { navigate } from '@/utils/NavigationUtils'
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'
import ImageWrapper from '@/components/rahmen/ImageWrapper.vue'

function goToRegistration(): void {
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.ACCOUNT_REGISTRATION_PAGE)
}

function goToLogin(): void {
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE)
}
</script>
<style scoped lang="scss">
.card {
  max-width: 500px;
}

:deep(.card) {
  margin-bottom: 0 !important;
}

#registration-button {
  width: 100%;
}

#login-button {
  width: 100%;
}
</style>
